import React, { createContext, useContext, useState } from 'react';

// Create the context
const UserExpendedContext = createContext(undefined);

const UserExpendedProvider = ({ children }) => {
  const [userExpanded, setUserExpanded] = useState(false);

  return (
    <UserExpendedContext.Provider value={[userExpanded, setUserExpanded]}>
      {children}
    </UserExpendedContext.Provider>
  );
};

const useUserExpended = () => {
  const context = useContext(UserExpendedContext);
  if (context === undefined) {
    throw new Error('useUserExpended must be used within a UserExpendedProvider');
  }
  return context;
};

export { UserExpendedProvider, useUserExpended };
